import { Component, OnInit } from '@angular/core';
import { EmailService } from '../../services/email.service';
import { Email } from '../../models/email.model';
import { DataStorageService } from '../../services/data-storage.service';
import { Email2 } from '../../models/email2.model';
import { Email2Service } from '../../services/email2.service';
import { Response } from '@angular/http';


@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.css']
})
export class ReviewsComponent implements OnInit {
  emails:Email2[];

  

  constructor(private email2Service:Email2Service,private dataStorageService:DataStorageService) { }

  ngOnInit() {
    this.dataStorageService.getEmail2();
    this.email2Service.emailChanged2.subscribe(
      (emails:Email2[])=>{
        this.emails=emails;
      }
    );
    this.emails=this.email2Service.getEmail();
    console.log('emails',this.emails);
    
  }
  delete(i){
    this.email2Service.remove(i);
    this.dataStorageService.storeEmail2().subscribe(
      (response:Response) => {
        console.log(response);
      }
    );
  }
  
      

}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/components/reviews/reviews.component.ts